module.exports = __webpack_public_path__ + "static/media/step2.c826b88c.png";